export const en = {
    'empty-selected-screens': 'No screen selected',
    'need-to-select-city': 'Please select a city'
};
